import React from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import SelectBox from "@/components/SelectBox";
import { INDIAN_STATES } from "@/lib/states";

export const EMPTY_NEW_CUSTOMER = { customer_name: "", mobile: "", state: "", gst_no: "", address: "", city: "" };

// Returns customer id: reuses existing customer with same mobile, else creates a new one
export async function ensureCustomer(newCust, parties) {
  const last10 = (v) => (v || "").replace(/\D/g, "").slice(-10);
  const mobile = last10(newCust.mobile);
  const gst = (newCust.gst_no || "").trim().toUpperCase();
  const match = parties.find(p => (mobile && last10(p.mobile) === mobile) || (gst && (p.gst_no || "").trim().toUpperCase() === gst));
  if (match) return match.id;
  const { data } = await api.post("/customers", {
    ...newCust,
    customer_name: newCust.customer_name.trim(),
    display_name: newCust.customer_name.trim(),
    mobile,
    gst_no: gst,
    billing_street1: newCust.address, billing_city: newCust.city, billing_state: newCust.state,
    place_of_supply: newCust.state,
    customer_type: newCust.gst_no ? "business" : "individual",
  });
  return data.id;
}

export default function CustomerPicker({ value, onChange, parties, newCust, setNewCust, testid, disableNew }) {
  const isNew = !!newCust;
  const upd = (k, v) => setNewCust({ ...newCust, [k]: v });
  return (
    <div data-testid={`${testid}-picker`}>
      {!disableNew && (
        <div className="flex gap-3 text-xs mb-1">
          <button type="button" onClick={() => setNewCust(null)} data-testid={`${testid}-mode-existing`}
            className={!isNew ? "font-semibold text-[hsl(24.6_95%_45%)] underline" : "text-muted-foreground hover:text-foreground"}>
            Existing customer
          </button>
          <button type="button" onClick={() => { onChange(""); setNewCust({ ...EMPTY_NEW_CUSTOMER }); }} data-testid={`${testid}-mode-new`}
            className={isNew ? "font-semibold text-[hsl(24.6_95%_45%)] underline" : "text-muted-foreground hover:text-foreground"}>
            + New customer
          </button>
        </div>
      )}
      {!isNew ? (
        <SelectBox value={value} onChange={onChange} testid={testid} placeholder="Select customer"
          options={parties.map(p => ({ value: p.id, label: p.customer_name + (p.mobile ? ` (${p.mobile})` : "") }))} />
      ) : (
        <div className="grid grid-cols-2 gap-2 p-2 rounded-md border border-dashed border-[hsl(24.6_95%_53.1%)] bg-orange-50/40">
          <Input placeholder="Customer name *" value={newCust.customer_name} onChange={e => upd("customer_name", e.target.value)} data-testid={`${testid}-new-name`} />
          <Input placeholder="Mobile" value={newCust.mobile} onChange={e => upd("mobile", e.target.value)} data-testid={`${testid}-new-mobile`} />
          <select value={newCust.state} onChange={e => upd("state", e.target.value)} data-testid={`${testid}-new-state`}
            className="h-10 px-3 border border-border rounded-md bg-card text-sm">
            <option value="">State (GST ke liye)</option>
            {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <Input placeholder="GSTIN (optional)" value={newCust.gst_no} onChange={e => upd("gst_no", e.target.value)} data-testid={`${testid}-new-gst`} />
          <Input placeholder="Address" value={newCust.address} onChange={e => upd("address", e.target.value)} data-testid={`${testid}-new-address`} />
          <Input placeholder="City" value={newCust.city} onChange={e => upd("city", e.target.value)} data-testid={`${testid}-new-city`} />
          <p className="col-span-2 text-[11px] text-muted-foreground">Bill save karte hi customer automatically Customers list me add ho jayega.</p>
        </div>
      )}
    </div>
  );
}
